(function () {
  'use strict';

  var focusSelector = 'a[href], button, input, select, textarea, [tabindex]';

  function isFocusable(element, drawer, view) {
    if (element.tabIndex < 0 || element.disabled || element.matches(':disabled')) return false;
    for (var node = element; node; node = node.parentElement) {
      if (node.hidden || node.hasAttribute('inert') || node.getAttribute('aria-hidden') === 'true') return false;
      var style = view.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
      if (node === drawer) break;
    }
    return element.getClientRects().length > 0;
  }

  function init(doc) {
    var drawer = doc.getElementById('cart-drawer');
    var view = doc.defaultView;
    if (!drawer || !view || !view.MutationObserver) return null;
    if (drawer.__acCartAccessibility) return drawer.__acCartAccessibility;

    var headers = Array.prototype.slice.call(doc.querySelectorAll('.header-cart'));
    var open = false;
    var opener = null;
    var pendingOpener = null;
    var closeRequested = false;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-labelledby', 'ac-cart-title');
    drawer.setAttribute('tabindex', '-1');
    headers.forEach(function (header) { header.setAttribute('aria-controls', 'cart-drawer'); });

    function focusables() {
      return Array.prototype.slice.call(drawer.querySelectorAll(focusSelector)).filter(function (element) {
        return isFocusable(element, drawer, view);
      });
    }

    function focusFirst() {
      var items = focusables();
      (items[0] || drawer).focus();
    }

    function sync() {
      var next = drawer.classList.contains('active');
      var changed = next !== open;
      var active = doc.activeElement;
      if (next && changed) {
        opener = pendingOpener && pendingOpener.isConnected ? pendingOpener : active;
        pendingOpener = null;
      }
      // Restore before making the drawer inert; inert may itself blur a control.
      if (!next && changed && opener && opener.isConnected &&
          (active === doc.body || drawer.contains(active))) opener.focus();
      open = next;
      drawer.setAttribute('aria-hidden', next ? 'false' : 'true');
      if (next) {
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-modal', 'true');
      } else {
        drawer.setAttribute('inert', '');
        drawer.removeAttribute('aria-modal');
      }
      headers.forEach(function (header) { header.setAttribute('aria-expanded', next ? 'true' : 'false'); });
      if (changed) {
        closeRequested = false;
        if (next) {
          var close = drawer.querySelector('.close-cart');
          if (close && isFocusable(close, drawer, view)) close.focus();
          else focusFirst();
        } else {
          opener = null;
          pendingOpener = null;
        }
      }
    }

    function rememberTrigger(event) {
      if (open || !event.target || !event.target.closest) return;
      var header = event.target.closest('.header-cart');
      if (header && headers.indexOf(header) !== -1) pendingOpener = header;
    }

    function onKeydown(event) {
      if (!open) {
        if (event.key === 'Enter' || event.key === ' ') rememberTrigger(event);
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        var close = drawer.querySelector('.close-cart');
        if (!closeRequested && close) {
          closeRequested = true;
          close.click();
        }
        return;
      }
      if (event.key === 'Tab') {
        event.preventDefault();
        var items = focusables();
        var index = items.indexOf(doc.activeElement);
        if (index === -1) focusFirst();
        else items[(index + (event.shiftKey ? -1 : 1) + items.length) % items.length].focus();
        return;
      }
      if (event.key === ' ' && event.target && event.target.closest) {
        var anchor = event.target.closest('a[role="button"]');
        if (anchor && drawer.contains(anchor) && isFocusable(anchor, drawer, view)) {
          event.preventDefault();
          event.stopPropagation();
          if (!event.repeat) anchor.click();
        }
      }
    }

    var observer = new view.MutationObserver(sync);
    var controller = { sync: sync, focusables: focusables };
    drawer.__acCartAccessibility = controller;
    doc.addEventListener('click', rememberTrigger, true);
    doc.addEventListener('keydown', onKeydown, true);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
    return controller;
  }

  function boot(doc) {
    if (doc.readyState === 'loading') {
      if (doc.__acCartAccessibilityReady) return;
      doc.__acCartAccessibilityReady = true;
      doc.addEventListener('DOMContentLoaded', function () { init(doc); }, { once: true });
    } else init(doc);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { init: init, boot: boot, isFocusable: isFocusable };
  if (typeof document !== 'undefined') boot(document);
}());